import { IBFRecordParsingDefinition } from "@/lib/drivers/insulet/IBFRecords/RecordParser";
import { Version } from "@/lib/drivers/insulet/OmnipodTypes";

type IBFPDMVersion = {
  pdmVersion: Version;
  model: "Dash" | "Eros";
};

export const IBF_PDM_VERSION = {
  // Value is just the order in which the items are present in the file
  value: 2,
  name: "IBF_PDM_VERSION",
  size: 3,
  parse: record => {
    const pdmVersion = record.nextVersion();
    const model = pdmVersion.major >= 3 ? "Dash" : "Eros";

    return {
      pdmVersion,
      model,
    };
  },
} satisfies IBFRecordParsingDefinition<IBFPDMVersion>;
